/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCreateRequestItemsSchema } from "./banquetCreateRequestItemsSchema.ts";
import { highlightedItemSchema } from "./highlightedItemSchema.ts";
import { localizationListSchema } from "./localizationListSchema.ts";
import { localizationStrSchema } from "./localizationStrSchema.ts";

export const groupSchema = z.object({
	is_force_hidden_with_allowed_creation: z
		.boolean()
		.optional()
		.describe("Флаг, указывающий фронту на необходимость скрытия группы. Допускает создание заказа с блюдами из данной группы."),
	is_combo_group: z
		.boolean()
		.optional()
		.describe(
			"Группа-контейнер для всех комбо точки. Блюда к ней не привязываются — фронт сам раскладывает в неё список из /combos/. Отдаётся только когда в меню есть видимые комбо. Создаётся вручную: заполните название и картинку, external_id оставьте пустым. Синхронизация меню такую группу не деактивирует, при том, что её нет в выгрузке iiko.",
		),
	highlighted_item: highlightedItemSchema.nullable(),
	child_groups: z.array(banquetCreateRequestItemsSchema),
	id: z.uuid(),
	name: z.string().max(255),
	tags: z.array(z.string()),
	adult: z.boolean().optional(),
	loc_tags: localizationListSchema.describe("Util serializer for representation in swagger"),
	loc_name: localizationStrSchema.describe("Util serializer for representation in swagger"),
	image_link: z.string().nullable(),
	video_link: z.string().nullable(),
});
